import type { ScriptTagConfig } from './types.js';

export default (config: ScriptTagConfig): string => {
  const { account, profile, environment, async = true } = config || {};

  if (account && profile && environment) {
    return `<${[
      'script',
      async ? 'async' : null,
      `src="https://tags.tiqcdn.com/utag/${account}/${profile}/${environment}/utag.js"`,
    ]
      .filter(Boolean)
      .join(' ')}></script>`;
  }

  return '';
};
